/** 从稿面 DOM 抓取某章正文（章标题块之后、下一章之前的所有小节） */
export function collectChapterDraftFromDom(chapterNo: number): string {
  const head = document.querySelector(`[data-chapter-no="${chapterNo}"]`)
  if (!head) return ''
  const parts: string[] = []
  let node = head.nextElementSibling
  while (node) {
    if (node.hasAttribute('data-chapter-no') || node.hasAttribute('data-chapter-id')) break
    if (node.hasAttribute('data-scene-id')) {
      const t = (node as HTMLElement).innerText?.trim()
      if (t) parts.push(t)
    }
    node = node.nextElementSibling
  }
  return parts.join('\n\n').trim()
}
